import { useEffect } from "react";
import { useAppSelector } from "../redux/typedHooks";
import { UserInterface } from "../types/user";
import { useCreditsQuery, queryClient, queryKeys } from "../query";

/**
 * Один глобальний запит за credits (React Query).
 * Той самий кеш використовується скрізь; dedupe + staleTime 15 с.
 * При логауті кеш очищається.
 */
export const useCreditsBalance = () => {
  const user = useAppSelector<UserInterface | null>(
    state => state.user.currentUser
  );
  const {
    data: balance,
    isLoading: loading,
    error,
    refetch,
  } = useCreditsQuery();

  useEffect(() => {
    if (!user) {
      queryClient.removeQueries({ queryKey: queryKeys.credits });
    }
  }, [user]);

  const errorMessage =
    error instanceof Error ? error.message : error ? String(error) : null;

  return {
    balance: balance ?? null,
    loading,
    error: errorMessage,
    refetch,
    hasCredits: balance ? (balance.totalCredits ?? 0) > 0 : false,
    creditsRemaining: balance?.totalCredits ?? 0,
    totalCredits: balance?.totalCredits ?? 0,
    usedCredits: balance?.usedCredits ?? 0,
  };
};

export default useCreditsBalance;
